import { FC, ReactNode } from 'react';
import { BsXLg } from 'react-icons/bs';
import classes from './style.module.scss';
type Tprops = {
    open: boolean,
    children: ReactNode,
    maxHeight?: string
    onClose?: () => void
}
const SuggestionBox: FC<Tprops> = ({ open, children, maxHeight, onClose }) => {
    if (!children) {
        return (
            <></>
        )
    }
    return (
        <div className='pos-relative'>
            <div className={`${classes.suggestionbox}`} data-open={open} style={{ maxHeight: maxHeight }}>
                {children}
                {(typeof onClose === 'function' && open === true) && <BsXLg className='icon-button' onClick={onClose} style={{ position: 'sticky', left: 'calc(50% - 1rem)', bottom: '.7rem', background: '#dfe7f3', borderRadius: '50%', zIndex: 2 }} />}
            </div>
        </div>

    )
}
export default SuggestionBox;